<template>
<main id="content">
    <cq-breadcrumbs :history="pathHistory"></cq-breadcrumbs>
    <div class="row">
        <div class="col s12 ">
            <cq-datatable
                class="col l12 datatable"
                :title="title"
                :columns="columns"
                :rows="rows"

                v-on:row-click="gotToEditUser"
            ></cq-datatable>
        </div>
    </div>
    <div class="row">
        <div class="col s12 ">
            <br>

            <br>
        </div>
    </div>
    <div class="fixed-action-btn">
        <router-link
            to="/users/add"
            class="btn-floating btn-large"
        ><i class="large material-icons">add</i></router-link>
    </div>
</main>
</template>

<script>
import { db } from '../../main';
import DataTable from 'vue-materialize-datatable';
import Breadcrumbs from '../../components/commun/Breadcrumbs.vue';
import router from '../../router';

export default {
  data() {
    return {
      pathHistory: [
        {
          route: '/',
          name: 'Inicio',
        },
        {
          route: '/users',
          name: 'Usuarios',
        },
      ],
      title: 'Usuarios Registrados',
      columns: [
        {
          label: 'Nombre Completo', // Column name
          field: 'fullname', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
        {
          label: 'Correo', // Column name
          field: 'email', // Field name from row
          numeric: false, // Affects sorting
          html: false, // Escapes output if false.
        },
      ],
      rows: [],
    };
  },
  components: {
    cqBreadcrumbs: Breadcrumbs,
    cqDatatable: DataTable,
  },
  created() {
    const vueInstance = this;
    db
      .ref('users')
      .once('value')
      .then((usersSnapshot) => {
        usersSnapshot.forEach((userSnapShot) => {
          vueInstance.rows.push({
            fullname: userSnapShot.val().name,
            email: userSnapShot.val().email,
            uid: userSnapShot.key,
          });
        });
      });
  },
  methods: {
    gotToEditUser(row) {
      console.log(row);
      router.push({ name: 'user-edit', params: { id: row.uid, name: row.fullname } });
    },
  },
};
</script>

<style scoped>
.datatable {
  margin-bottom: 60px;
}
</style>
